import script from "./readonly.vue?vue&type=script&lang=js"
export * from "./readonly.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__